// Moved from `src/hooks/query/useQueryDocumentsBySessionId.ts` (now a
// delegate) at D5, ARCFE-990. The token crosses the seam hook; the CAPTURE
// gate (`isOfflineLocalSession`, an offline-recording predicate over the
// session cache) is an INPUT per the ratified cohort-C rule — the delegate
// reads the session cache at render time and passes the decision, exactly
// as the legacy hook computed it. No session → capture edge exists here.
import { useQuery } from '@tanstack/react-query';
import { GET_DOCUMENTS_BY_ID } from '../../contracts';
import { getDocumentsBySessionId } from '../api/documents';
import { getSessionDataConfig } from '../config';

export function useQueryDocumentsBySessionId(
  sessionId: string,
  { isOfflineLocalSession = false }: { isOfflineLocalSession?: boolean } = {}
) {
  const token = getSessionDataConfig().useAuthToken?.();

  return useQuery({
    queryKey: [GET_DOCUMENTS_BY_ID, { sessionId }],
    enabled: !!sessionId && !!token && !isOfflineLocalSession,
    queryFn: async () => {
      const { data } = await getDocumentsBySessionId(sessionId);
      if (data) {
        return data;
      }
      // throw new Error(error.detail?.at(0)?.msg); // React Query expects errors to be thrown to show a message
    },
  });
}
